/**
 * The page is imported from **its own module**, not from the `@pages` barrel — the barrel would pull
 * every page into one preloaded chunk and defeat code-splitting by route.
 */
import { createFileRoute } from '@tanstack/react-router';

import { SharedI18n } from '@shared';

import { ActCardPage } from '@pages/acts/act-card-page.js';
import { IamService } from '@units/iam';

/**
 * `/acts/{actId}` — карточка акта: статус, журнал оснований, связи, последствия отмены.
 *
 * Гард — `act:read`, и отказ здесь **404, а не 403**, в отличие от раздела: существование раздела
 * внутри организации не тайна, а существование конкретного акта — тайна, и сообщать о нём тому, кто
 * его видеть не вправе, значит делать API оракулом (`rules/permissions.mdc`, инвариант 2).
 */
export const Route = createFileRoute('/_authenticated/acts/$actId')({
  beforeLoad: IamService.IamGuards.requirePermission({
    permission: 'act:read',
    whenDenied: 'not-found',
  }),
  /* Тот же словарь и та же причина, что у реестра: `acts.json` вне первой загрузки, ждём его здесь. */
  loader: () => SharedI18n.loadCatalogue('acts'),
  component: ActCardPage,
  staticData: { crumbKey: 'nav.acts' },
});
